import { Promoter } from './Promoter';

export const PromoterD2R = () => <Promoter />;
